import * as React from 'react'

import PhotoAlbum from 'react-photo-album'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import Video from 'yet-another-react-lightbox/plugins/video'
import {
  videosGalleryModal,
  videosSlidesModal,
} from '../../DetailPageDataUtils'
import { useState } from 'react'
import axios from 'axios'
import { useEffect } from 'react'
import { isEmpty } from 'lodash'

// import photos from './Photos'
// import slides from './Slides'

const VideoGallery = (props) => {
  const [thumbnailList, setThumbnailList] = useState([])
  const [slideList, setSlideList] = useState([])
  // const [imagesList, setImagesList] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalResults, setTotalResults] = useState(0)
  const [index, setIndex] = React.useState(-1)

  const [controls, setControls] = React.useState(false)
  const [playsInline, setPlaysInline] = React.useState(true)
  const [autoPlay, setAutoPlay] = React.useState(true)
  const [loop, setLoop] = React.useState(true)
  const [muted, setMuted] = React.useState(false)
  const [disablePictureInPicture, setDisablePictureInPicture] = React.useState(
    false,
  )
  const [disableRemotePlayback, setDisableRemotePlayback] = React.useState(
    false,
  )
  const [controlsList, setControlsList] = React.useState([])
  const [crossOrigin, setCrossOrigin] = React.useState('')
  const [preload, setPreload] = React.useState('')

  // console.log(props.videos)

  // let dispatch = useDispatch()
  console.log('props.videos', props.videos)
  console.log('props.videoSlides', props.videoSlides)
  useEffect(() => {
    setThumbnailList(props.videos)
    setSlideList(props.videoSlides)
    // setImagesList(props.images)
    // return () => {
    //   setThumbnailList([])
    //   setSlideList([])
    //   // dispatch(flushImagesGalleryData())
    //   // dispatch(flushVideosGalleryData())
    // }
  }, [])

  const fetchMoreData = async () => {
    setPage(page + 1)
    try {
      var url = `https://tripdevapi.unravelapp.com/api/v1/item/videos?itemId=${props.id}&pageNumber=${page}&pageSize=20`
      var host = window.location.hostname
      if (host === 'trip.unravelapp.com' || host === 'trips.unravelapp.com') {
        var url = `https://tripapi.unravelapp.com/api/v1/item/videos?itemId=${props.id}&pageNumber=${page}&pageSize=20`
      }

      let response = await axios.get(url, {
        headers: { token: `${props.tokenStr}` },
      })

      console.log(response.data.data)
      // dispatch(getImagesGalleryData(response.data.data))
      let thumbnailArr = videosGalleryModal(response.data.data)
      let videoslidesArr = videosSlidesModal(response.data.data)
      // setThumbnailList(thumbnailList.concat(thumbnailArr))
      if (!isEmpty(thumbnailList)) {
        setThumbnailList(thumbnailList.concat(thumbnailArr))
      } else {
        setThumbnailList(props.videos.concat(thumbnailArr))
      }
      setSlideList(slideList.concat(videoslidesArr))
    } catch (error) {
      throw Error(error)
    }
  }

  return (
    <>
      <PhotoAlbum
        layout="rows"
        photos={isEmpty(thumbnailList) ? props.videos : thumbnailList}
        targetRowHeight={250}
        onClick={({ index }) => setIndex(index)}
      />
      {!isEmpty(props.totalPages) &&
        thumbnailList.length < props.totalPages.total_elements &&
        props.videos.length < props.totalPages.total_elements && (
          <p
            className="headline2"
            style={{
              textAlign: 'center',
              border: '1px solid var(--primaryShades20)',
              color: 'var(--primaryShades20)',
              padding: '3px',
              cursor: 'pointer',
            }}
            onClick={fetchMoreData}
          >
            Load more..
          </p>
        )}
      {/* <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        slides={slides}
      /> */}

      <Lightbox
        open={index >= 0}
        close={() => setIndex(-1)}
        index={index}
        slides={isEmpty(slideList) ? props.videoSlides : slideList}
        plugins={[Video]}
        video={{
          controls,
          playsInline,
          autoPlay,
          loop,
          muted,
          disablePictureInPicture,
          disableRemotePlayback,
          controlsList: controlsList.join(' '),
          crossOrigin,
          preload,
        }}
      />
    </>
  )
}

export default VideoGallery
